"use client";

import { lienPartage, messagePartage, parametresCarte } from "@/lib/tools/partage";

/**
 * Envoyer sa situation à un ami, d'un geste.
 *
 * Sur téléphone, la feuille de partage du système, avec la carte en image et
 * le message personnel. Ailleurs, le message et le lien vont dans le
 * presse-papiers, prêts à coller dans une conversation. Rien ne part vers
 * Believemy : le lien ne porte aucune réponse.
 *
 * @returns {Promise<"partage"|"copie"|"annule">}
 */
export async function partagerSituation({ r, part = null, lang = "fr", source = "carte", avecImage = true, projet = false }) {
    const lien = lienPartage(window.location.origin, lang, source);
    const { texte } = messagePartage(r, lang, { projet });
    try {
        if (avecImage) {
            const blob = await (await fetch(`/api/og/situation?${parametresCarte(r, part, lang)}`)).blob();
            const fichier = new File([blob], lang === "en" ? "my-situation.png" : "ma-situation.png", { type: "image/png" });
            const donnees = { files: [fichier], text: `${texte} ${lien}` };
            if (navigator.canShare?.(donnees)) {
                await navigator.share(donnees);
                return "partage";
            }
        }
        if (navigator.share && window.matchMedia?.("(pointer: coarse)").matches) {
            await navigator.share({ text: texte, url: lien });
            return "partage";
        }
    } catch (e) {
        if (e?.name === "AbortError") return "annule";
    }
    try {
        await navigator.clipboard.writeText(`${texte} ${lien}`);
    } catch (e) {
        window.prompt("", `${texte} ${lien}`);
    }
    return "copie";
}

/** Copier seulement : le message et le lien, sans ouvrir de feuille. */
export async function copierMessage({ r, lang = "fr", source = "carte" }) {
    const texte = `${messagePartage(r, lang).texte} ${lienPartage(window.location.origin, lang, source)}`;
    try {
        await navigator.clipboard.writeText(texte);
    } catch (e) {
        window.prompt("", texte);
    }
}
